import { StatusTag, type StatusTagTone } from '../../../components/StatusTag';
import type { CatalogoRef } from '@aid/shared';

interface EstadoClienteTagProps {
  estado: CatalogoRef | null;
}

// Tones semánticos: ACTIVO es el único estado positivo del catálogo;
// BAJA (De Baja) y cualquier estado negativo se marcan en rojo.
const estadoTones: Record<string, StatusTagTone> = {
  activo: 'success',
  baja: 'error',
  inactivo: 'error',
  suspendido: 'warning',
  cancelado: 'error',
};

export function EstadoClienteTag({ estado }: EstadoClienteTagProps) {
  if (!estado) return <StatusTag>N/A</StatusTag>;
  const key = estado.key?.toLowerCase() ?? '';
  return (
    <StatusTag tone={estadoTones[key] ?? 'neutral'}>
      {estado.value ?? estado.key ?? 'N/A'}
    </StatusTag>
  );
}
